import React, { useCallback, useEffect, useState } from "react";
import Table from "../components/table/Table";

import config from "../api/config";
import "../assets/css/customers.css";

import { useDispatch, useSelector } from "react-redux";
import { setToast } from "../redux/actions/ToastAction";
import { Button, Snackbar, Switch } from "@mui/material";
import Alert from "../components/alert";
import CollapsibleCategory from "../components/CollapsibleCategory";
import EditingCat from "../components/EditingCat";
import AlertDialog from "../components/Modal";

const ControlCat = () => {
  const [Cats, setCats] = useState([]);
  const [subcatsBoolean, setSubcatsBoolean] = useState(false);
  // modal
  const [modal, setModal] = useState(false);
  const [activeCat, setActiveCat] = useState(null);
  const [loading, setLoading] = useState(false);
  // delete
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteID, setDeleteID] = useState(0);
  // snackbar
  const reducer = useSelector((state) => state.reducer.toast);
  const dispatch = useDispatch();
  const toastHandler = () => {
    dispatch(setToast(false, "success", ""));
  };
  // get data
  // get all cats
  const getAllCats = useCallback(() => {
    setLoading(true);

    config
      .get(`/api/category/v1`)
      .then((data) => {
        setLoading(false);
        setCats(data.data.objectKoinot);

      })
      .catch((err) => {
        setLoading(false);
      });
    config
      .get(`/api/adminVariables/v1`)
      .then((data) => {
        setLoading(false);
        setSubcatsBoolean(data.data.objectKoinot.subCategory);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);
  useEffect(() => { getAllCats(); }, [getAllCats]);

  // get subcat boolean
  const handleAdminVariables = async () => {
    setLoading(true);
    await config
      .post(`/api/adminVariables/v1`)
      .then((data) => {
        setLoading(false);
        setSubcatsBoolean(data.data.objectKoinot);
      })
      .catch((err) => {
        setLoading(false);
      });
    getAllCats();
  };

  const editCatHandler = (obj, parent) => {
    let object = structuredClone(obj);
    if (parent) object.parentCategory = parent;
    setActiveCat(object);
  };
  // delete
  const beforeDeleteCatHandler = (id) => {
    setDeleteID(id);
    setDeleteModal(true);
  };

  const deleteCatHandler = async () => {
    try {
      const res = await config.delete(`/api/category/v1/${deleteID}`);
      setModal(false);
      getAllCats();
      dispatch(setToast(true, "success", res.data.message));
    } catch (e) {
      dispatch(setToast(true, "error", e.message));
    }
  };

  // save edited Group
  const saveHandler = async (bool, object) => {
    if (bool) {

      try {
        const res = await config.post(`/api/category/v1`, object);
        setModal(false);
        getAllCats();
        dispatch(setToast(true, "success", res.data.message));
      } catch (e) {
        dispatch(setToast(true, "error", e.message));
      }
    }
  };

  // table data'
  const headData = ["", "ID", "Eng", "Rus", "Uzb", "Цена(сум)"];
  const renderHead = (item, index) => <th key={index}>{item}</th>;
  // menu data
  const renderBody = (item) => (
    <CollapsibleCategory
      item={item}
      clickHandlerEDIT={editCatHandler}
      clickHandlerDELETE={beforeDeleteCatHandler}
      modal={modal}
      modalHandler={(e) => setModal(e)}
    />
  );

  // create new category
  const handleCreate = () => {
    setActiveCat({
      nameEn: "",
      nameRu: "",
      nameUz: "",
      parentCategory: null,
      price: 0,
    });
    setModal(true);
  };
  return (
    <div className="">
      <Snackbar
        open={reducer.toast}
        autoHideDuration={4000}
        onClose={toastHandler}
      >
        <Alert
          onClose={toastHandler}
          severity={reducer.severity}
          sx={{ width: "100%" }}
        >
          {reducer.content}
        </Alert>
      </Snackbar>
      {/* editing */}
      <EditingCat
        cat={activeCat}
        _callback={saveHandler}
        modal={modal}
        setModal={() => setModal(!modal)}
      />
      {/* deleting */}
      <AlertDialog
        text="Вы действительно хотите удалить это?"
        boo={deleteModal}
        setModal={(e) => setDeleteModal(e)}
        _callback={(e) => deleteCatHandler(e)}
      />

      <div className="d-flex justify-content-between align-items-center">
        <h2 className="page-header">Категории</h2>
        <Button onClick={handleCreate} variant="contained">
          Создать новый
        </Button>
      </div>
      {/* switch subcategories */}
      <div className="d-flex justify-content-between align-items-center w-auto">
        <h4>Подкатегории</h4>
        <Switch
          value="checkedA"
          inputProps={{ "aria-label": "Switch A" }}
          checked={subcatsBoolean}
          onChange={handleAdminVariables}
        />
      </div>
      <div className="row pb-5 cat">
        <div className="col-12">
          <Table
            headData={headData}
            renderHead={(item, index) => renderHead(item, index)}
            bodyData={Cats}
            renderBody={(item, index) => renderBody(item, index)}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default ControlCat;
